<template>
  <div class="page-add">
    <div class="add-title">
      {{ addTitle }}
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="100px"
      class="form"
      size="small"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="标题：" prop="newsTitle">
            <el-input
              placeholder="请输入标题"
              v-model="ruleForm.newsTitle"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="类型：" prop="newsType">
            <el-select
              v-model="ruleForm.newsType"
              placeholder="新闻类型"
              style="width:100%;"
            >
              <el-option
                v-for="(item, i) in newsTypeList"
                :key="i"
                :label="item.paramValue"
                :value="item.paramKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="来源：" prop="newsSource">
            <el-input
              placeholder="请输入来源"
              v-model="ruleForm.newsSource"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="作者：" prop="newsAuthor">
            <el-input
              placeholder="请输入作者"
              v-model="ruleForm.newsAuthor"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        class="scale"
        label="配图："
        prop="coverUrl"
        :rules="{
          required: true,
          message: '请上传图片'
        }"
        :show-message="showErrorimg"
      >
        <div
          v-if="ruleForm.coverUrl"
          id="video-output"
          @mouseenter="showCover = true"
          @mouseleave="showCover = false"
        >
          <img :src="ruleForm.coverUrl" class="avatar" />
          <div v-show="showCover" class="cover-bg">
            <i
              class="el-icon-zoom-in delete"
              @click.stop="showViewer = true"
            ></i>
            <i class="el-icon-delete delete" @click.stop="deleteCover"></i>
          </div>
        </div>
        <el-upload
          v-else
          action=""
          class="avatar-uploader"
          :show-file-list="false"
          :http-request="uploadCover"
          accept="png,jpg,jpeg"
          :limit="1"
          ref="coverUpload"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <label v-if="!ruleForm.coverUrl" class="upload-text">上传图片</label>
        </el-upload>
      </el-form-item>
      <el-form-item label="是否置顶：" prop="setTop">
        <el-radio-group v-model="ruleForm.setTop">
          <el-radio
            v-for="(item, i) in topList"
            :key="i"
            :label="item.paramKey"
            >{{ item.paramValue }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-row>
        <el-col>
          <el-form-item label="内容类型：" prop="newsSkipType" required>
            <el-radio-group
              v-model="ruleForm.newsSkipType"
              @change="changeRadio"
            >
              <el-radio
                v-for="(item, i) in skipList"
                :key="i"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="内容："
            prop="newsCon"
            :rules="{ required: true, message: '请输入新闻内容' }"
            :show-message="showError"
            v-if="ruleForm.newsSkipType == 0"
          >
            <!--            <rich-text
              :detail.sync="ruleForm.newsCon"
              @change-con="changeCon"
              uploadUrl="news/richText"
            ></rich-text>-->
            <weditor
                    :detail.sync="ruleForm.newsCon"
                    uploadUrl="news/richText"
                    @change-con="changeCon"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="链接地址："
            prop="newsLink"
            :show-message="showErrorLink"
            v-if="ruleForm.newsSkipType == 1"
          >
            <el-input
              placeholder="请输入链接地址"
              v-model="ruleForm.newsLink"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="text-align: center;">
        <el-button @click="reset">重置</el-button>
        <el-button @click="$router.back()">返回</el-button>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[ruleForm.coverUrl]"
    />
  </div>
</template>

<script>
/* eslint-disable */
// import richText from '@/components/RichText/index'
import weditor from '@/components/weditor/index';
import { newsSave, newsUpdate } from "@/api/news";
import { getSysParamByTypes } from "@/api/sysParam";
import rulesFactory from "@/utils/rules";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import FileHandler from "@/utils/file";
export default {
  components: {
   // richText,
    ElImageViewer,
    weditor
  },
  data() {
    let validcodeName = (rule, value, callback) => {
      //let reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
      //let reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
      let reg = /(http|ftp|https):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
      if (value) {
        if (!reg.test(value)) {
          this.showErrorLink = true;
          callback(new Error("请输入正确的链接"));
        } else {
          this.showErrorLink = false;
          callback();
        }
      } else {
        this.showErrorLink = true;
        callback(new Error("请输入链接"));
      }
    };
    return {
      ruleForm: {
        newsTitle: "",
        newsContent: "",
        newsType: "",
        newsSource: "",
        coverUrl: "",
        newsAuthor: "",
        newsSkipType: "0",
        newsLink: "",
        newsCon: "",
        setTop: "0"
      },
      showError: false,
      showErrorLink: false,
      showViewer:false,
      showCover: false,
      showErrorimg:false,
      addTitle: "新增新闻",
      editFlag: false,
      edituuid: "",
      dialogVisible: false,
      dialogImageUrl: "",
      newsTypeList: [],
      topList: [],
      skipList: [],
      rules: {
        newsTitle: [
          { required: true, message: "请输入新闻标题", trigger: "blur" },
          rulesFactory.size("最多输入100个字", 0, 100)
        ],
        // newsContent: [
        //   {
        //     required: true,
        //     message: "请输入新闻内容或者新闻链接"
        //   }
        // ],
        newsType: [
          { required: true, message: "请选择新闻类型", trigger: "change" }
        ],
        coverUrl: [
          { required: true, message: "请上传配图", trigger: "change" }
        ],
        newsSource: [
          { required: true, message: "请输入来源", trigger: "blur" },
          rulesFactory.size("最多输入20个字", 0, 20)
        ],
        newsAuthor: [
          { required: true, message: "请输入作者", trigger: "blur" },
          rulesFactory.size("最多输入20个字", 0, 20)
        ],
        setTop: [
          { required: true, message: "请选择是否置顶", trigger: "change" }
        ],
        newsLink: [
          // { required: true, message: "请输入标题", trigger: "blur" },
          { required: true, validator: validcodeName, trigger: "blur" }
          // { validator: validcodeName, trigger: "change" }
        ]
      }
    };
  },
  created() {
    this.getSysParamByTypes(["NEWS_TYPE", "IS_VALID", "NEWS_SKIP_TYPE"]);
    if (this.$route.query.newsDetail) {
      this.addTitle = "编辑新闻";
      this.editFlag = true;
      let newsDetail = this.$route.query.newsDetail;
      this.ruleForm.newsTitle = newsDetail.newsTitle;
      this.ruleForm.newsType =  newsDetail.newsType.toString();
      this.ruleForm.newsSource = newsDetail.newsSource;
      this.ruleForm.coverUrl = newsDetail.coverUrl;
      this.ruleForm.newsAuthor = newsDetail.newsAuthor;
      this.ruleForm.setTop = newsDetail.setTop.toString();
      this.ruleForm.newsSkipType = newsDetail.newsSkipType.toString();
      if (newsDetail.newsSkipType == 0) {
        this.ruleForm.newsCon = newsDetail.newsContent;
      } else {
        this.ruleForm.newsLink = newsDetail.newsContent;
      }
      this.ruleForm.onlineStatus = newsDetail.onlineStatus;
      this.edituuid = newsDetail.uuid;
    } else {
      this.addTitle = "新增新闻";
      this.editFlag = false;
    }
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.newsTypeList = res.data["NEWS_TYPE"];
        this.topList = res.data["IS_VALID"];
        this.skipList = res.data["NEWS_SKIP_TYPE"];
      });
    },
    onSubmit() {
      this.$refs["ruleForm"].validate(valid => {
        if (!this.ruleForm.newsCon) {
          this.showError = true;
        }
        if (!this.ruleForm.newsLink) {
          this.showErrorLink = true;
        }
        if (!this.ruleForm.coverUrl) {
          this.showErrorimg = true;
        }
        if (valid) {
          this.$confirm(`确认提交吗？`, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              if (this.editFlag) {
                this.ruleForm.uuid = this.edituuid;
                if (this.ruleForm.newsSkipType == 0) {
                  this.ruleForm.newsContent = this.ruleForm.newsCon;
                } else {
                  this.ruleForm.newsContent = this.ruleForm.newsLink;
                }
                newsUpdate(this.ruleForm).then(res => {
                  if (!res || res.code != 0) return;
                  this.$router.back();
                  this.$refs["ruleForm"].resetFields();
                });
              } else {
                this.ruleForm.onlineStatus = 0;
                if (this.ruleForm.newsSkipType == 0) {
                  this.ruleForm.newsContent = this.ruleForm.newsCon;
                } else {
                  this.ruleForm.newsContent = this.ruleForm.newsLink;
                }
                newsSave(this.ruleForm).then(res => {
                  if (!res || res.code != 0) return;
                  this.$router.back();
                  this.$refs["ruleForm"].resetFields();
                });
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    changeCon(data) {
      this.ruleForm.newsCon = data;
      if (!this.ruleForm.newsCon) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
    cancel() {
      this.$router.back();
      this.$refs["ruleForm"].resetFields();
    },
    handleExeed() {
      alert("只能上传一张图片");
    },
    changeRadio() {
      this.showError = false;
      this.showErrorLink = false;
    },
    async uploadCover(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning"
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`news/img`, file).then(res => {
        const { url } = res;
        this.ruleForm.coverUrl = url;
      });
    },
    closeViewer() {
      this.showViewer = false;
    },
    deleteCover() {
      this.ruleForm.coverUrl = "";
    },
    reset() {
      this.$confirm(`确认重置表单吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (this.editFlag) {
            this.ruleForm.newsTitle = ''
            this.ruleForm.newsContent = ''
            this.ruleForm.newsType = ''
            this.ruleForm.newsSource = ''
            this.ruleForm.newsAuthor = ''
            this.ruleForm.newsLink = ''
            this.ruleForm.newsCon = ''
            this.ruleForm.coverUrl = ''
            this.ruleForm.coverUrl = ''
          this.$refs["coverUpload"].clearFiles();
          } else {
            this.ruleForm.coverUrl = ''
          this.$refs["coverUpload"].clearFiles();
          this.$refs["ruleForm"].resetFields();
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 320px;
  height: 160px;
  display: block;
  object-fit: contain;
}
.upload-text {
  color: $textColor;
  font-size: 13px;
}
#video-output {
    width: 320px;
    height: 160px;
    position: relative;
    .cover-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(1, 1, 1, 0.5);
      z-index: 199;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      color: #ffffff;
      .delete {
        font-size: 20px;
        cursor: pointer;
      }
    }
}
.upload_tip {
  width: 320px;
  text-align: center;
  margin-top: 10px;
}
.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}
.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}
</style>
